<div class="tenant-switcher-modal">
  <h2 class="modal-title">Select the Environment</h2>

  <div class="modal-content">
    <p class="modal-description">{{ tenantSwitcherDescription }}</p>

    <div class="environment-dropdown">
      <gains-select [formControl]="environmentControl" placeholder="Select the environment" [items]="environments" [mode]="'default'" [loading]="isLoading"> </gains-select>
    </div>
  </div>

  <div class="modal-footer">
    <button nz-button nzType="default" nzShape="round" (click)="onCancel()">Cancel</button>
    <button nz-button nzType="primary" nzShape="round" (click)="onConfirm()" [disabled]="!environmentControl.valid">Confirm</button>
  </div>
</div>
